import { useCallback, useState } from "react"

export default function useAsyncError() {
  const [, setError] = useState()

  return useCallback(
    (e) => {
      setError(() => {
        throw e
      })
    },
    [setError]
  )
}
